export default {
      id: "grid-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#grid",
      toString: function () {
        return this.url;
      }
    }